import { Link } from 'react-router-dom';

const RecentEnrollments = ({ enrollments = [] }) => {
  if (!enrollments.length) {
    return (
      <div className="py-4 text-center text-stone-500">
        No recent enrollments found
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {enrollments.map((enrollment) => (
        <div
          key={enrollment.id}
          className="rounded-[22px] border border-stone-200 bg-stone-50 p-4 transition-colors duration-200 hover:border-stone-300 hover:bg-white"
        >
          <div className="flex items-center justify-between gap-4">
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-semibold text-stone-950">
                  {enrollment.studentName}
                </span>
                <span className="text-stone-500">enrolled in</span>
                <span className="font-semibold text-stone-950">
                  {enrollment.courseName}
                </span>
              </div>
              <p className="mt-1 text-sm text-stone-500">
                {enrollment.enrollmentDate
                  ? new Date(enrollment.enrollmentDate).toLocaleDateString(
                      'en-US',
                      {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      },
                    )
                  : 'Invalid date'}
              </p>
            </div>
            <div>
              <span
                className={`rounded-full px-3 py-1 text-xs font-semibold ${
                  enrollment.status === 'active'
                    ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'
                    : 'bg-amber-50 text-amber-700 ring-1 ring-amber-200'
                }`}
              >
                {enrollment.status || 'pending'}
              </span>
            </div>
          </div>
        </div>
      ))}
      <div className="mt-4 text-right">
        <Link
          to="/enrollments"
          className="text-sm font-medium text-[#b91c66] transition hover:text-[#9d174d]"
        >
          View all enrollments
        </Link>
      </div>
    </div>
  );
};

export default RecentEnrollments;
